"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BASKET_PROVIDER_POLL_TIMEOUT: true,
  LOG_COLOR: true
};
exports.LOG_COLOR = exports.BASKET_PROVIDER_POLL_TIMEOUT = void 0;
var _constantsGenerated = require("./constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
/** The poll timeout / interval for checking the shopping bag provider ready promise availability. */
const BASKET_PROVIDER_POLL_TIMEOUT = exports.BASKET_PROVIDER_POLL_TIMEOUT = 250;
const LOG_COLOR = exports.LOG_COLOR = '90c';
